import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import tr from './locales/tr.json'

const savedLanguage = localStorage.getItem('language') || 'en'

// Keep <html lang> in sync with the active language
document.documentElement.lang = savedLanguage
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
